var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2372 17.871H8.16635C7.18756 17.871 6.39746 17.0809 6.39746 16.1021C6.39746 15.1234 7.18756 14.3333 8.16635 14.3333H18.2313C19.2101 14.3333 20.0002 15.1234 20.0002 16.1021C20.0002 17.0809 19.2101 17.871 18.2313 17.871H18.2372Z",
    fill: "#ba120e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2372 10.766H8.16635C7.18756 10.766 6.39746 9.97594 6.39746 8.99716C6.39746 8.01837 7.18756 7.22827 8.16635 7.22827H18.2313C19.2101 7.22827 20.0002 8.01837 20.0002 8.99716C20.0002 9.97594 19.2101 10.766 18.2313 10.766H18.2372Z",
    fill: "#ba120e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2372 3.66693H8.16635C7.18756 3.66693 6.39746 2.87682 6.39746 1.89804C6.39746 0.919255 7.18756 0.12915 8.16635 0.12915H18.2313C19.2101 0.12915 20.0002 0.919255 20.0002 1.89804C20.0002 2.87682 19.2101 3.66693 18.2313 3.66693H18.2372Z",
    fill: "#ba120e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77126 17.871H1.76889C0.790103 17.871 0 17.0809 0 16.1021C0 15.1234 0.790103 14.3333 1.76889 14.3333H2.77126C3.75004 14.3333 4.54015 15.1234 4.54015 16.1021C4.54015 17.0809 3.75004 17.871 2.77126 17.871Z",
    fill: "#ba120e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77126 10.766H1.76889C0.790103 10.766 0 9.97594 0 8.99716C0 8.01837 0.790103 7.22827 1.76889 7.22827H2.77126C3.75004 7.22827 4.54015 8.01837 4.54015 8.99716C4.54015 9.97594 3.75004 10.766 2.77126 10.766Z",
    fill: "#ba120e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77126 3.66693H1.76889C0.790103 3.66693 0 2.87682 0 1.89804C0 0.919255 0.790103 0.12915 1.76889 0.12915H2.77126C3.75004 0.12915 4.54015 0.919255 4.54015 1.89804C4.54015 2.87682 3.75004 3.66693 2.77126 3.66693Z",
    fill: "#ba120e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.965454f81ed4535c8d6c0aca8742b7e3.svg";
export { ForwardRef as ReactComponent };